import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import useStyles from './styles';

const RadioCard = (props: RadioCardProps) => {
  const { value, active, Icon, displayText } = props;
  const { classes } = useStyles();
  return (
    <FormControlLabel
      value={value}
      control={<Radio color="primary" />}
      className={clsx(classes.radioCard, active && classes.activeRadioCard)}
      label={
        <div className={classes.contentContainer}>
          <Icon className={clsx(classes.icon, active && classes.activeText)} />
          <Typography className={clsx(active && classes.activeText)}>
            {displayText}
          </Typography>
        </div>
      }
    />
  );
};

export interface RadioCardProps {
  value: string;
  active: boolean;
  Icon: React.ElementType;
  displayText: string;
}

export default RadioCard;
